import { render, staticRenderFns } from "./CategorySupplyDemand.vue?vue&type=template&id=37a243dc&scoped=true"
import script from "./CategorySupplyDemand.vue?vue&type=script&lang=js"
export * from "./CategorySupplyDemand.vue?vue&type=script&lang=js"
import style0 from "./CategorySupplyDemand.vue?vue&type=style&index=0&id=37a243dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a243dc",
  null
  
)

export default component.exports